import http from '@/services/http';

const measures = {
  index() {
    return http.request({
      method: 'get',
      url: '/measures',
    });
  },
  autocompleteFetch(name) {
    const filter = {
      where: {
        description: { regexp: `/${name || ''}/i` },
      },
    };
    return http.request({
      method: 'get',
      url: '/measures',
      params: { filter },
    });
  },
};

export default measures;
